<template>
    <div @click="$emit('click')" class="border border-radius rounded my-3 cursor-pointer shadow-sm p-3">


        <div class="d-flex justify-content-between pb-2 mb-2 border-bottom">
            <small class="px-2 d-block align-text-start font-weight-bolder">
                {{summary}}
            </small>

            <div @click.stop="show" v-if="hasChildren">
                <i-cascade></i-cascade>
            </div>
        </div>

        <div class="d-flex position-relative">
            <div class="flex-1 border-gray p-2" :class="rtl">
                <small class="d-flex font-weight-bold">
                    <span><i-calendar></i-calendar> {{t('Date')}}</span>
                </small>

                <small class="d-flex">
                  {{$moment.utc(date).format("DD-MM-YYYY")}}
                  <!--                    {{$moment.utc(date).format("DD-MM-YYYY HH:mm")}}-->
                </small>
            </div>

            <div class="flex-1 p-2">
                <small class="d-flex font-weight-bold">
                    <span><i-doctor></i-doctor> {{t('Doctor name')}}</span>
                </small>

                <small class="d-flex">
                    {{name}}
                </small>
            </div>

            <div :class="back"
                 class="flex-shrink-0 position-absolute bg-some-other-skyler-variation rounded p-1 d-flex align-items-center">
                <i-arrow width=".8em" height=".8em"></i-arrow>
            </div>
        </div>
    </div>
</template>

<script>
    import IDoctor from "../Icons/IDoctor";
    import ICalendar from "../Icons/ICalendar";
    import IArrow from "../Icons/IArrow";
    import ICascade from "../Icons/ICascade";

    export default {
        name: "ConsultationCard",
        components: {
            IDoctor, ICalendar, IArrow, ICascade
        },
        methods: {
            show() {
                this.$router.push({
                    name: 'consultation children',
                    params: {encounter_id: +this.rootEncounterId}
                })
            }
        },
        computed: {
            rtl() {
                return this.$translate.lang === 'en' ? 'border-right' : 'border-left';
            },

            back() {
                return this.$translate.lang === 'en' ? 'back' : 'back-rtl';
            },

            children() {
                return this.$translate.lang === 'en' ? 'children' : 'children-rtl';
            }
        },
        props: {
            summary: {
                type: String,
                required: true
            },
            date: {
                type: [String, Date],
                required: true
            },
            name: {
                type: String,
                required: true
            },
            hasChildren: {
                type: Boolean,
                required: true
            },
            rootEncounterId: {
                type: Number,
            }
        }
    }
</script>

<style scoped>
    .back {
        right: -1.6em;
    }

    .back-rtl {
        left: -1.6em;
    }
</style>
